import { Node_Type } from "./../ricos-schema/next-schema/index.js";
const getTextFromNodes = (nodes = []) => nodes.map((node) => {
  if (node.type === Node_Type.TEXT && node.textData?.text) {
    return node.textData.text;
  }
  if (Array.isArray(node.nodes)) {
    return getTextFromNodes(node.nodes);
  }
  return "";
}).join("");
export {
  getTextFromNodes
};
//# sourceMappingURL=get-text-from-nodes.js.map
